import React from 'react';
import {Body, Headline} from '@lightricks/react-design-system';
import styles from './SlotGroupHeader.module.scss';

interface Props {
  label: string;
  approvedCount: number;
  requiredQuantity: number;
}

export default function SlotGroupHeader({
  label,
  approvedCount,
  requiredQuantity,
}: Props) {
  return (
    <div className={styles.header} data-testid="slot-group-header">
      <Headline size="sm">{label}</Headline>
      <Body size="xs">{`${approvedCount} of ${requiredQuantity} approved`}</Body>
    </div>
  );
}
